import { connect } from 'react-redux';

import StatisticsModalComponent from './../Components/StatisticsModalComponent.jsx';
import { modal as modalActions } from './../actions';
import {
  getBuildPageBuilds,
  getBuildPageBaselineBuilds,
  getStatistics,
  getModalVisibility
} from './../reducers';
import { build, modals } from './../helpers';

const getNames = builds => builds.map(b =>
  `${build.getBuildFriendlyName(b)} ${build.getBuildVersion(b)}`
);

export const mapStateToProps = (state) => {
  const builds = getBuildPageBuilds(state);
  const baselineBuilds = getBuildPageBaselineBuilds(state);

  return {
    visible: getModalVisibility(state, modals.owners.statistics),
    stats: getStatistics(state),
    currentNames: getNames(builds),
    baselineNames: getNames(baselineBuilds)
  };
};

export default connect(
  mapStateToProps,
  { onHide: () => modalActions.showStatisticsModal(false) }
)(StatisticsModalComponent);


// WEBPACK FOOTER //
// src/Containers/StatisticsModalContainer.jsx